import { Checkbox, FormControlLabel } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { ButtonPrimary } from "../../components/buttonStyles/style";
import { Input, SelectInput } from "../../components/Inputs";
import LazyLoading from "../../components/lazyLoading";
import SeasonsList from "../../components/Lists/SeasonsList";
import SuccessImage from "../../images/main/green_circle_tick.svg";
import { H5, LoadingIcon, TextBold } from "../../components/textStyles/style";
import { categories } from "../../data/SelectOptions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import MultipleSelect from "../../components/MulitpleSelect";

let Height = "calc(100vh - clamp(54px, 8vw, 84px) - 62px)";

const LoadingWrapper = styled.div`
  width: 100vw;
  min-height: ${Height};
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 100%;
  min-height: ${Height};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-evenly;
  margin: 30px 0;
`;

const FormWrapper = styled.div`
  background-color: white;
  width: 50%;
  padding: 30px;
  border-radius: 20px;
  z-index: 1;
`;

const InfosWrapper = styled.div`
  background-color: white;
  width: 35%;
  padding: 30px;
  border-radius: 20px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
`;

const MultiRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
`;

const UpdateTrail = () => {
  const MySwal = withReactContent(Swal);
  const { i18n } = useTranslation();
  const { trail_code } = useParams();
  const [code, setCode] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [showTitle, setShowTitle] = useState("");
  const [link, setLink] = useState("");
  const [episodesNumber, setEpisodesNumber] = useState("");
  const [poster, setPoster] = useState("");
  const [category, setCategory] = useState("");
  const [studioImage, setStudioImage] = useState([]);
  const [studioAudio, setStudioAudio] = useState([]);
  const [translationAgency, setTranslationAgency] = useState([]);
  const [author, setAuthor] = useState([]);
  const [source, setSource] = useState("");
  const [voice, setVoice] = useState([]);
  const [scriptwriter, setScriptwriter] = useState([]);
  const [keywords, setKeywords] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [srt, setSrt] = useState(false);
  const [free, setFree] = useState(false);
  const [dailyLimit, setDailyLimit] = useState(false);
  const [seasons, setSeasons] = useState([]);
  const [experts, setExperts] = useState([]);
  const TOKEN = localStorage.getItem("TOKEN");

  useEffect(() => {
    const getTrailData = async () => {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      };
      // get experts list
      const ex = await axios.get(
        process.env.REACT_APP_GET_EXPERTS_DROPDOWN,
        config
      );

      setExperts(ex.data);

      // trail data
      const response = await axios.get(
        `${process.env.REACT_APP_GET_TRAILS}/${trail_code}?language=${i18n.language}`,
        config
      );
      const trail = response.data;
      // SET INPUTS TO Trail VALUES
      setCode(trail.trail_code);
      setTitle(trail.title);
      setShowTitle(trail.title);
      setDescription(trail.description);
      setLink(trail.link);
      setEpisodesNumber(trail.episodes_number);
      setPoster(trail.poster_link);
      setCategory(trail.category);
      setStudioImage(trail.image_studio);
      setSource(trail.source ? trail.source : "");
      setStudioAudio(trail.audio_studio);
      setTranslationAgency(trail.translation_agency);
      setAuthor(trail.author);
      setScriptwriter(trail.scriptwriter);
      setVoice(trail.voice);
      setSrt(trail.srt);
      setKeywords(trail.keywords);
      setSeasons(trail.seasons);
      setFree(trail.free);
      setDailyLimit(trail.daily_limit);
      setLoading(false);
    };
    getTrailData();
  }, [i18n, trail_code, TOKEN]);

  // UPDATE SUBMIT
  const submitHandler = async () => {
    setSubmitLoading(true);
    setErrorMessage("");
    try {
      const data = {
        access_token: TOKEN,
        trail_code: code,
        language: i18n.language,
        link,
        title,
        description,
        poster_link: poster,
        author,
        source,
        voice,
        audio_studio: studioAudio,
        image_studio: studioImage,
        translation_agency: translationAgency,
        keywords,
        episodes_number: Number(episodesNumber),
        srt,
        category,
        scriptwriter,
        free,
        daily_limit: dailyLimit,
      };

      await axios.put(process.env.REACT_APP_UPDATE_TRAIL, data);
      setTimeout(() => {
        setSubmitLoading(false);

        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setShowTitle(title);
        MySwal.fire({
          title: <H5>Modifications Saved</H5>,
          html: <></>,
          imageUrl: SuccessImage,
          imageWidth: 200,
          imageHeight: 150,
          imageAlt: "Custom image",
          timer: 1500,
          showConfirmButton: false,

          timerProgressBar: true,
          padding: "2vw",
          showCloseButton: true,
          showClass: {
            popup: "animate__animated animate__fadeInDown animate__fast",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp animate__faster",
          },
        });
      }, 1000);
      setSubmitLoading(false);
    } catch (error) {
      setSubmitLoading(false);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setErrorMessage("Probléme de Connexion");
    }
  };

  if (loading) {
    return (
      <LoadingWrapper>
        <LazyLoading height={Height} />
      </LoadingWrapper>
    );
  }

  return (
    <Wrapper>
      <FormWrapper>
        <H5>Update Trail : {showTitle}</H5>
        <Row>
          <TextBold color="#c22222">
            {errorMessage ? errorMessage : " "}
          </TextBold>
        </Row>
        {/** trail code + title */}
        <Row>
          <Input
            disabled={true}
            placeholder="Trail Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <Input
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Row>

        {/** description */}
        <Row>
          <Input
            placeholder="Description"
            multiline={true}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Row>
        {/** category */}
        <Row>
          <SelectInput
            values={categories}
            placeholder="Catégorie"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
          <Input
            type="number"
            placeholder="Nombre Total des épisodes"
            value={episodesNumber}
            onChange={(e) => setEpisodesNumber(e.target.value)}
          />
        </Row>
        {/** link + poster link */}
        <Row>
          <Input
            placeholder="Trailer Link (not required)"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
          <Input
            placeholder="Poster Link"
            value={poster}
            onChange={(e) => setPoster(e.target.value)}
          />
        </Row>
        {/** keywords */}
        <Row>
          <Input
            placeholder="Keywords (séparés avec ,) ex: confiance,émotion,stress"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
          />
        </Row>
        {/** author + voice */}
        <MultiRow>
          <MultipleSelect
            placeholder="Auteur"
            options={experts}
            selectedValues={author}
            setSelectedValues={setAuthor}
          />
          <MultipleSelect
            placeholder="Voix"
            options={experts}
            selectedValues={voice}
            setSelectedValues={setVoice}
          />
        </MultiRow>
        <Row>
          <Input
            placeholder="Source"
            value={source}
            onChange={(e) => setSource(e.target.value)}
          />
        </Row>
        {/** studio audio + studio image */}
        <MultiRow>
          <MultipleSelect
            placeholder="Studio Audio"
            options={experts}
            selectedValues={studioAudio}
            setSelectedValues={setStudioAudio}
          />
          <MultipleSelect
            placeholder="Studio Image"
            options={experts}
            selectedValues={studioImage}
            setSelectedValues={setStudioImage}
          />
        </MultiRow>
        {/** translation agency + scriptwriter */}
        <MultiRow>
          <MultipleSelect
            placeholder="Translation agency"
            options={experts}
            selectedValues={translationAgency}
            setSelectedValues={setTranslationAgency}
          />
          <MultipleSelect
            placeholder="Script Writer"
            options={experts}
            selectedValues={scriptwriter}
            setSelectedValues={setScriptwriter}
          />
        </MultiRow>

        <Row>
          <FormControlLabel
            style={{ marginRight: 30 }}
            control={
              <Checkbox
                checked={srt}
                onChange={() => setSrt(!srt)}
                color="success"
              />
            }
            label="Srt ?"
          />
          <FormControlLabel
            style={{ marginRight: 30 }}
            control={
              <Checkbox
                checked={free}
                onChange={() => setFree(!free)}
                color="success"
              />
            }
            label="Free ?"
          />
          <FormControlLabel
            style={{ marginRight: 30 }}
            control={
              <Checkbox
                checked={dailyLimit}
                onChange={() => setDailyLimit(!dailyLimit)}
                color="success"
              />
            }
            label="Limite des épisodes ?"
          />
        </Row>
        <Row style={{ marginTop: 40 }}>
          <ButtonPrimary onClick={submitHandler}>
            {submitLoading ? <LoadingIcon color="inherit" /> : "Enregister"}
          </ButtonPrimary>
        </Row>
      </FormWrapper>
      <InfosWrapper>
        <SeasonsList seasons={seasons} trail_code={trail_code} />
      </InfosWrapper>
    </Wrapper>
  );
};

export default UpdateTrail;
